import React, { Component } from "react";
import { Container, Row, Col } from "reactstrap";

class Pricing extends Component {
  state = {
    plans: [
      {
        id: 1,
        title: "Starter",
        subtitle: "Perfect for small businesses and startups",
        price: "$29",
        duration: "/month",
        cta: "Get Started",
        ctaLink: "/register",
        featured: false,
        features: [
          "Up to 25 employees",
          "Basic payroll",
          "Standard reports",
          "Email support",
          "Accounting",
        ],
      },
      {
        id: 2,
        title: "Professional",
        subtitle: "For growing businesses with advanced needs",
        price: "$99",
        duration: "/month",
        cta: "Get Started",
        ctaLink: "/register",
        featured: true,
        badge: "Most Popular",
        features: [
          "Up to 50 employees",
          "Advanced payroll features",
          "Custom reports & analytics",
          "Priority support (24/7)",
          "API access",
          "Multi-location support",
        ],
      },
      {
        id: 3,
        title: "Enterprise",
        subtitle: "For large organizations with complex requirements",
        price: "Custom",
        duration: "",
        cta: "Contact Sales",
        ctaLink: "/contact",
        featured: false,
        features: [
          "Unlimited employees",
          "Enterprise-grade features",
          "Advanced integrations",
          "Dedicated account manager",
          "Custom SLA",
          "On-premise deployment option",
        ],
      },
    ],
  };

  render() {
    return (
      <section className="pwlp-pricing" id="pricing">
        <Container>
          <div className="pwlp-pricing__heading">
            <h2 className="pwlp-pricing__title">Simple, Transparent Pricing</h2>
            <p className="pwlp-pricing__desc">
              Choose the plan that fits your business needs. All plans include
              core features with 24/7 support.
            </p>
          </div>

          <div className="pwlp-pricing-table">
            <Row className="g-0 pwlp-pricing__grid">
              {this.state.plans.map((plan) => (
                <Col lg="4" md="12" key={plan.id} className="pwlp-pricing__col">
                  <div
                    className={`pwlp-pricing-card ${
                      plan.featured ? "pwlp-pricing-card--featured" : ""
                    }`}
                  >
                    {plan.badge ? (
                      <div className="pwlp-pricing-card__badge">{plan.badge}</div>
                    ) : null}

                    <div className="pwlp-pricing-card__body">
                      <h3 className="pwlp-pricing-card__title">{plan.title}</h3>

                      <p className="pwlp-pricing-card__subtitle">
                        {plan.subtitle}
                      </p>

                      <div className="pwlp-pricing-card__price-wrap">
                        <span className="pwlp-pricing-card__price">
                          {plan.price}
                        </span>

                        {plan.duration ? (
                          <span className="pwlp-pricing-card__duration">
                            {plan.duration}
                          </span>
                        ) : null}
                      </div>

                      <div className="pwlp-pricing-card__features">
                        {plan.features.map((feature, index) => (
                          <p key={index} className="pwlp-pricing-card__feature">
                            <span className="pwlp-pricing-card__check">✓</span>
                            <span>{feature}</span>
                          </p>
                        ))}
                      </div>
                    </div>

                    <div className="pwlp-pricing-card__footer">
                      <a
                        href={plan.ctaLink}
                        className={`pwlp-pricing-card__btn ${
                          plan.featured ? "pwlp-pricing-card__btn--featured" : ""
                        }`}
                      >
                        {plan.cta}
                      </a>
                    </div>
                  </div>
                </Col>
              ))}
            </Row>
          </div>

          <p className="pwlp-pricing__note">
            All plans include a 14-day free trial. No credit card required.
          </p>
        </Container>
      </section>
    );
  }
}

export default Pricing;



// import React, { Component } from "react";
// import { Container, Row, Col } from "reactstrap";

// class Pricing extends Component {
//   state = {
//     plans: [
//       {
//         id: 1,
//         title: "Starter",
//         subtitle: "Perfect for small businesses and startups",
//         price: "$49",
//         duration: "/month",
//         cta: "Get Started",
//         ctaLink: "/register",
//         featured: false,
//         features: [
//           "Up to 25 employees",
//           "Basic payroll processing",
//           "Standard reports",
//           "Email support",
//           "Mobile app access",
//         ],
//       },
//       {
//         id: 2,
//         title: "Professional",
//         subtitle: "For growing businesses with advanced needs",
//         price: "$149",
//         duration: "/month",
//         cta: "Get Started",
//         ctaLink: "/register",
//         featured: true,
//         badge: "Most Popular",
//         features: [
//           "Up to 100 employees",
//           "Advanced payroll features",
//           "Custom reports & analytics",
//           "Priority support (24/7)",
//           "API access",
//           "Multi-location support",
//         ],
//       },
//       {
//         id: 3,
//         title: "Enterprise",
//         subtitle: "For large organizations with complex requirements",
//         price: "Custom",
//         duration: "",
//         cta: "Contact Sales",
//         ctaLink: "/contact",
//         featured: false,
//         features: [
//           "Unlimited employees",
//           "Enterprise-grade features",
//           "Advanced integrations",
//           "Dedicated account manager",
//           "Custom SLA",
//           "On-premise deployment option",
//         ],
//       },
//     ],
//   };

//   render() {
//     return (
//       <section className="pwlp-pricing" id="pricing">
//         <Container>
//           <div className="pwlp-pricing__heading">
//             <h2 className="pwlp-pricing__title">Simple, Transparent Pricing</h2>
//             <p className="pwlp-pricing__desc">
//               Choose the plan that fits your business needs. All plans include
//               core features with 24/7 support.
//             </p>
//           </div>

//           <Row className="pwlp-pricing__grid">
//             {this.state.plans.map((plan) => (
//               <Col lg="4" md="6" className="mb-4" key={plan.id}>
//                 <div
//                   className={`pwlp-pricing-card ${
//                     plan.featured ? "pwlp-pricing-card--featured" : ""
//                   }`}
//                 >
//                   {plan.badge ? (
//                     <div className="pwlp-pricing-card__badge">{plan.badge}</div>
//                   ) : null}

//                   <h3 className="pwlp-pricing-card__title">{plan.title}</h3>
//                   <p className="pwlp-pricing-card__subtitle">{plan.subtitle}</p>

//                   <div className="pwlp-pricing-card__price-wrap">
//                     <span className="pwlp-pricing-card__price">{plan.price}</span>
//                     {plan.duration ? (
//                       <span className="pwlp-pricing-card__duration">
//                         {plan.duration}
//                       </span>
//                     ) : null}
//                   </div>

//                   <div className="pwlp-pricing-card__features">
//                     {plan.features.map((feature, index) => (
//                       <p key={index} className="pwlp-pricing-card__feature">
//                         <span className="pwlp-pricing-card__check">✓</span>
//                         {feature}
//                       </p>
//                     ))}
//                   </div>

//                   <a
//                     href={plan.ctaLink}
//                     className={`pwlp-pricing-card__btn ${
//                       plan.featured ? "pwlp-pricing-card__btn--featured" : ""
//                     }`}
//                   >
//                     {plan.cta}
//                   </a>
//                 </div>
//               </Col>
//             ))}
//           </Row>
//         </Container>
//       </section>
//     );
//   }
// }

// export default Pricing;
// import React, { Component } from "react";
// import { Container, Row } from "reactstrap";

// //Import Section Title
// import SectionTitle from "../common/section-title";

// //Import Pricing
// import PricingBox from "./pricing-box";

// class Pricing extends Component {
//   state = {
//   pricings: [
//     {
//       id: 1,
//       title: "Flexible Plan",
//       price: "$19.99",
//       duration: "MONTH",
//       features: {
//         invoices: "Included",
//         checks: "Included",
//         accounting: "$2 per account/month",
//         selfPayroll: "$2 per employee/month",
//         taxfile: "Not Included"
//       }
//     }
//   ]
// };

//   render() {
//     return (
//       <React.Fragment>
//         <section className="section bg-light" id="pricing">
//           <Container>
//             {/* Render section title */}
//             <SectionTitle
//               title="Our Pricing"
//             />

//             <Row className="mt-5">
//               {/* Render Pricing Box */}
//               {this.state.pricings.map((pricing, key) => (
//                 <PricingBox key={key} pricing={pricing} />
//               ))}
//             </Row>
//           </Container>
//         </section>
//       </React.Fragment>
//     );
//   }
// }

// export default Pricing;
